// modules
import WrongCredentialsModalComponent from './wrongCredentialsModal';
import InfiniteScroll from './infinite-scroll';
//import LanguagesComponent from './languages';
import UiCheckbox from './angular-bootstrap-checkbox';
import UiMask from './ui-mask';
import FormValidatorsDirectives from './formValidators';

import SpinnerPreloader from './preloader.css'; // only CSS

export default angular.module(
	'app.components.module',
	[
		WrongCredentialsModalComponent,
		InfiniteScroll,
		UiCheckbox,
		UiMask,
		FormValidatorsDirectives
	])

	.name;


/** WEBPACK FOOTER **
 ** ./src/components/index.js
 **/